module.exports = __webpack_public_path__ + "img/logo_soroubat.42b4673e.png";